var _userLoginTokenDetail;
import { io } from 'socket.io-client';
import { Config } from './api/config';
import { getLocalStorageItem } from './utils/storageHelper';
var userLoginTokenDetails = getLocalStorageItem('USER_LOGIN_DATA');
export var socketIO = io(Config === null || Config === void 0 ? void 0 : Config.WS_BASE_URL, {
    autoConnect: true,
    withCredentials: true,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    extraHeaders: {
        Authorization: 'Bearer ' + (userLoginTokenDetails === null || userLoginTokenDetails === void 0 || (_userLoginTokenDetail = userLoginTokenDetails.data) === null || _userLoginTokenDetail === void 0 ? void 0 : _userLoginTokenDetail.Token)
    }
});
socketIO.on('connect', function () {
    console.log('Socket connected successfully');
});
socketIO.on('connect_error', function (error) {
    console.error('Socket connection error:', error);
});
socketIO.on('disconnect', function (reason) {
    console.log('Socket disconnected:', reason);
    if (reason === 'io server disconnect') {
        socketIO.connect();
    }
});
